import { render, staticRenderFns } from "./stockForExpeditionModal.vue?vue&type=template&id=bb99f46e&"
import script from "./stockForExpeditionModal.vue?vue&type=script&lang=ts&"
export * from "./stockForExpeditionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports